import React, { useEffect, useState } from "react";
import ProfileAdmin from "./profiles/ProfileAdmin";
import ProfileConfirmator from "./profiles/ProfileConfirmator";
import ProfileSaller from "./profiles/ProfileSaller";
import Cookies from "js-cookie";
import { useAuth } from "../../context/AuthProvider";

export default function Page() {
  const [user, setUser] = useState(null);
  const { role } = useAuth();

  useEffect(() => {
    const userCookie = Cookies.get("user");
    if (userCookie) {
      try {
        const parsedUser = JSON.parse(userCookie); 
        setUser(parsedUser);
      } catch (error) {
        console.error("Invalid user cookie:", error);
      }
    }
  }, []);

  return (
    <div>
      {(role === 1 || role === 2) && <ProfileAdmin user={user} />}
      {role === 3 && <ProfileConfirmator user={user} />}
      {role === 0 && <ProfileSaller user={user} />}
    </div>
  );
}

